import { Component, input } from '@angular/core';
import { ButtonStyles } from '../../../../button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { ZiroIcons } from '../../../../shared/models/ziro-icons.enum';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ziro-migrations-card-header',
  imports: [TranslateModule, NgbTooltip],
  templateUrl: './migrations-card-header.component.html',
  styleUrl: './migrations-card-header.component.scss',
})
export class MigrationsCardHeaderComponent {
  ZiroIcons = ZiroIcons;
  ButtonStyles = ButtonStyles;

  readonly label = input.required<string>();
  readonly labelTooltip = input.required<string>();
}
